export default "__VITE_ASSET__CF0fcr66__"